import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "addButton"];
  static values = {
    fieldCount: Number,
  };

  connect() {
    this.attachRemoveHandlers();
  }

  addField(event) {
    event.preventDefault();

    const template = this.templateTarget;
    const clone = template.content.cloneNode(true);

    // Replace NEW_RECORD with unique timestamp
    const timestamp = new Date().getTime();
    const container = document.createElement("div");
    container.appendChild(clone);
    const html = container.innerHTML;
    const newHtml = html.replace(/NEW_RECORD/g, timestamp);

    this.containerTarget.insertAdjacentHTML("beforeend", newHtml);

    // Attach remove handler to the new field
    const newField = this.containerTarget.lastElementChild;
    const removeButton = newField.querySelector(".remove-field-btn");
    if (removeButton) {
      this.attachRemoveHandler(removeButton);
    }

    this.fieldCountValue++;
  }

  removeField(event) {
    event.preventDefault();

    const fieldItem = event.currentTarget.closest(".custom-field-item");
    const destroyInput = fieldItem.querySelector('input[name*="_destroy"]');

    if (destroyInput) {
      destroyInput.value = "1";
      fieldItem.style.display = "none";
    } else {
      fieldItem.remove();
    }
  }

  attachRemoveHandlers() {
    this.element.querySelectorAll(".remove-field-btn").forEach((button) => {
      this.attachRemoveHandler(button);
    });
  }

  attachRemoveHandler(button) {
    button.addEventListener("click", this.removeField.bind(this));
  }
}
